var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vs-table",
        {
          staticClass: "box-table",
          attrs: {
            "data-cy": "table",
            stripe: "",
            data: _vm.substitutes,
            noDataText: "Sin registros encontrados"
          },
          scopedSlots: _vm._u([
            {
              key: "default",
              fn: function(ref) {
                var data = ref.data
                return _vm._l(data, function(tr, indextr) {
                  return _c(
                    "vs-tr",
                    { key: indextr, attrs: { "data-cy": "file" } },
                    [
                      _c(
                        "vs-td",
                        { attrs: { data: data[indextr].remplazaNombre } },
                        [
                          _c("span", { staticClass: "d-flex" }, [
                            _c(
                              "span",
                              {
                                staticClass: "ml-3",
                                staticStyle: { "line-height": "40px" }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(data[indextr].remplazaNombre) +
                                    " "
                                )
                              ]
                            )
                          ])
                        ]
                      ),
                      _c(
                        "vs-td",
                        { attrs: { data: data[indextr].remplazoInicio } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFormat")(
                                  data[indextr].remplazoInicio
                                )
                              ) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "vs-td",
                        { attrs: { data: data[indextr].remplazoFin } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("dateFormat")(data[indextr].remplazoFin)
                              ) +
                              " "
                          )
                        ]
                      ),
                      _c(
                        "vs-td",
                        { attrs: { data: data[indextr].remplazaNombre } },
                        [
                          _c(
                            "div",
                            {},
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Editar suplente",
                                      expression: "'Editar suplente'"
                                    },
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        data[indextr].estado.toString() === "5",
                                      expression:
                                        "data[indextr].estado.toString() === '5'"
                                    }
                                  ],
                                  staticClass: "btn-icon rounded-circle",
                                  attrs: {
                                    "data-cy": "edit-substitution",
                                    variant: "flat-primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.editSubstitue(data[indextr])
                                    }
                                  }
                                },
                                [
                                  _c("feather-icon", {
                                    staticClass: "align-middle text-body p-0",
                                    attrs: { size: "18", icon: "EditIcon" }
                                  })
                                ],
                                1
                              ),
                              data[indextr].estado.toString() === "1"
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Pausar suplencia",
                                          expression: "'Pausar suplencia'"
                                        }
                                      ],
                                      staticClass: "btn-icon rounded-circle",
                                      attrs: {
                                        "data-cy": "pause-substitution",
                                        variant: "flat-warning"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.disableSubstitute(
                                            data[indextr]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass:
                                          "align-middle text-body p-0",
                                        attrs: {
                                          size: "18",
                                          icon: "PauseCircleIcon",
                                          variant: "danger"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              data[indextr].estado.toString() === "5"
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Retomar suplencia",
                                          expression: "'Retomar suplencia'"
                                        }
                                      ],
                                      staticClass: "btn-icon rounded-circle",
                                      attrs: {
                                        "data-cy": "resume-substitution",
                                        variant: "flat-success"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.enableSubstitute(
                                            data[indextr]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass:
                                          "align-middle text-body p-0",
                                        attrs: {
                                          size: "18",
                                          icon: "PlayCircleIcon"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              data[indextr].estado.toString() !== "5" &&
                              data[indextr].estado.toString() !== "1"
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value:
                                            "Procesando cambio en suplencia",
                                          expression:
                                            "'Procesando cambio en suplencia'"
                                        }
                                      ],
                                      staticClass: "btn-icon rounded-circle",
                                      attrs: {
                                        "data-cy": "resume-substitution",
                                        variant: "flat-warning"
                                      }
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass:
                                          "align-middle text-body p-0",
                                        attrs: {
                                          size: "18",
                                          icon: "LoaderIcon"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              data[indextr].estado.toString() === "5"
                                ? _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Archivar suplencia",
                                          expression: "'Archivar suplencia'"
                                        }
                                      ],
                                      staticClass: "btn-icon rounded-circle",
                                      attrs: {
                                        "data-cy": "file-substitution",
                                        variant: "flat-danger"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.storeSubstitute(
                                            data[indextr]
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("feather-icon", {
                                        staticClass:
                                          "align-middle text-body p-0",
                                        attrs: {
                                          size: "18",
                                          icon: "XCircleIcon"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                })
              }
            }
          ])
        },
        [
          _c(
            "template",
            { staticClass: "bg-primary", slot: "thead" },
            [
              _c("vs-th", [_vm._v("Nombre")]),
              _c("vs-th", [_vm._v("Inicio")]),
              _c("vs-th", [_vm._v("Fin")]),
              _c("vs-th", [_vm._v("...")])
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }